import { isDefined } from "@clipboard-health/util-ts";
import { Box, CircularProgress, Stack } from "@mui/material";
import { Text } from "@src/appV2/redesign/system/ui-components";
import { BadgePenaltyCounter } from "@src/appV2/redesign/WorkBadges/components/Policy/BadgePenaltyCounter";

import { BadgeVerificationExplanationLayout } from "./BadgeVerificationExplanationLayout";

const MAX_STRIKE_COUNT = 3;

interface BadgeVerificationMissedStepProps {
  strikeCount: number;
  notes?: string;
  isPhotoLoading: boolean;
  photoUrl?: string;
  onViewBadgePolicy: () => void;
  onNext: () => void;
}

export function BadgeVerificationMissedStep(props: BadgeVerificationMissedStepProps) {
  const { strikeCount, notes, isPhotoLoading, photoUrl, onViewBadgePolicy, onNext } = props;

  return (
    <BadgeVerificationExplanationLayout
      title="Your badge has not been verified"
      subtitle={notes}
      onViewBadgePolicy={onViewBadgePolicy}
      onNext={onNext}
    >
      <Stack direction="row" spacing={4} justifyContent="center">
        {Array.from({ length: MAX_STRIKE_COUNT }).map((_, index) => (
          <BadgePenaltyCounter
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            isFilled={index < strikeCount}
          />
        ))}
      </Stack>

      {isPhotoLoading && (
        <Stack alignItems="center" sx={{ paddingY: 6 }}>
          <CircularProgress size={32} />
        </Stack>
      )}

      {!isPhotoLoading && isDefined(photoUrl) && (
        <Stack alignItems="center">
          <Box
            component="img"
            src={photoUrl}
            alt="Your badge photo"
            sx={(theme) => ({
              width: "100%",
              maxWidth: 280,
              height: 280,
              objectFit: "cover",
              borderRadius: theme.borderRadius?.xSmall,
            })}
          />
        </Stack>
      )}

      {!isPhotoLoading && !isDefined(photoUrl) && (
        <Text
          variant="body2"
          color={(theme) => theme.palette.text.secondary}
          sx={{ textAlign: "center" }}
        >
          Your image couldn't be loaded, please contact support with any questions
        </Text>
      )}

      <Text
        variant="body2"
        color={(theme) => theme.palette.text.primary}
        sx={{ textAlign: "center" }}
      >
        Missing badge verification 3 times within 60 days will restrict you from badge-required
        workplaces for 30 days.
      </Text>
    </BadgeVerificationExplanationLayout>
  );
}
